import { AnsweringClient } from "../clients/answeringClient";

export interface ParceirosSelectYearControllerDelegate {
  submitedYear(): void;
  applicationShouldLogout(): void;
  genericError(): void;
}

export class ParceirosSelectYearController {
  constructor(
    private delegate: ParceirosSelectYearControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  async assignYear(year: number) {
    const accessToken = localStorage.getItem("AccessToken")!;
    await this.answeringClient.assignParceiros(year, accessToken);
    this.delegate.submitedYear();
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
